export const VIDEO_TYPES = Object.freeze({
  CONNECTING: 'connecting',
  STREAM: 'stream',
  GRID: 'grid',
});

export default {
  VIDEO_TYPES,
};
